import { css } from "@emotion/react";
import { Theme, useTheme } from "@mui/material";
import { FC } from "react";

const CategoryPill: FC<{ name: string }> = ({ name }) => {
  const theme = useTheme();
  return <div css={pillStyle(theme)}>{name}</div>;
};

const pillStyle = (theme: Theme) => css`
  width: fit-content;
  background-color: ${theme.palette.primary.main};
  color: ${theme.palette.primary.contrastText};
  border-radius: 1rem;
  padding: 2px 10px;
  font-size: 12px;
`;

export default CategoryPill;
